export default __webpack_public_path__ + "static/1-8c5628faf0fb3df79bc972e38945f404.jpeg";